import React from 'react';
import { Button, CssBaseline, Grid, Typography, withStyles } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
// import Preparing from '../components/Preparing';

import { EVENT_IMG } from '../constatns';
import SubTitle from '../components/Text/SubTitle';
import Stack from '@mui/material/Stack';

import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { FaArrowAltCircleRight } from 'react-icons/fa';
import './Korea.css';

const styles = (theme) => ({
  message: {
    padding: theme.spacing(2, 0, 5),
    color: '#555',
    textAlign: 'justifyContent',
    '& p': {
      marginBottom: '1.2em',
    },
  },
  divLine: {
    width: '100%',
    height: '1px',
    margin: theme.spacing(7, 0),
    backgroundColor: 'rgba(0,0,0,0.1)',
  },
});

//carousel data
const KCULTURE = [
  {
    contentName: 'K-Culture',
    contentList: [
      {
        img: 'culture_01.png',
        title: 'Korean Flag: Taegeukgi',
        text: 'The Taegeukgi consists of a white background with a taegeuk pattern in the middle and four gonggam-ri in a square. The Taegeukgi reflects the ideas brought by the Korean people, such as the belief in how the universe and everything are organized, the belief that Mother Nature embraces humans and its harmony is important, and our identity.',
      },
      {
        img: 'culture_02.png',
        title: 'Korean Traditional Costume: Hanbok',
        text: 'Hanbok is a traditional Korean costume that harmonizes straight lines and soft curves. Hanbok is a clothing with very beautiful, economical, active and potential harmony of line flow and color, and has excellent living and cultural value.',
      },
      {
        img: 'culture_03.png',
        title: 'Korean Traditional Martial Arts: Taekwondo',
        text: 'Taekwondo is a martial art that trains the body and mind to cultivate character, and it is a high-dimensional martial art that defends itself, not attacking others. Taekwondo uses hands and feet without weapons and features fast and powerful kick techniques.',
      },
    ],
    contentText:
      'Tradition and modernity live and breathe together in all arts, including music, art, literature, and dance, which are important parts of K-culture',
  },
];
const KPOP = [
  {
    contentName: 'K-Pop',
    contentList: [
      {
        img: 'pop_01.png',
        title: 'Write a New History of K-Pop : BTS ',
        text: 'BTS once again created the Korean Wave craze with K-pop as it received worldwide attention, topping the Billboard 200 chart in 2019 and winning the Billboard Music Awards top social artist award for the third consecutive year.',
      },
      {
        img: 'pop_02.png',
        title: "BTS and K-pop's Two Major Mountains: BLACKPINK",
        text: 'BLACKPINK ranked second on the Billboard main album chart "Billboard 200" and became the first K-POP group to be invited to the Coachella Music Festival in the United States, establishing itself as a leading K-pop girl group.',
      },
      {
        img: 'pop_03.png',
        title: "Raise K-pop Again: Psy's “Gangnam Style”",
        text: 'Psy\'s "Gangnam Style" ranked second on the Billboard Hot 100 chart for the seventh consecutive week in 2012 and surpassed 3 billion views of music videos on YouTube, spreading the K-Pop craze around the world in earnest.',
      },
    ],
    contentText:
      "K-pop is a generic name for popular music in Korea. K-pop's influence is gradually expanding and is proudly recognized as a genre that the world is paying attention to.",
  },
];

const KFOOD = [
  {
    contentName: 'K-Food',
    contentList: [
      {
        img: 'food_01.jpg',
        title: "Korea's Representative Fermented Food: Kimchi",
        text: 'Kimchi is a traditional fermented food in Korea. The types of kimchi are largely divided into cabbage kimchi, kkakdugi, dongchimi, and cucumber kimchi, which vary greatly depending on the region and season. Kimchi, a fermented food, not only has antibacterial and anticancer effects, but also has an effect of increasing immune activity.',
      },
      {
        img: 'food_02.jpg',
        title: 'Korean Food that No One Likes or Dislikes: Bulgogi',
        text: 'Bulgogi is a food with a long history of marinating and grilling meat in a sweet seasoning sauce. Bulgogi has a soft texture and a sweet taste, which is loved by men and women of all ages and is popular not only with Koreans but also with foreigners.',
      },
      {
        img: 'food_03.jpg',
        title: 'The leader of the Early Korean Culture: Bibimbap',
        text: 'Bibimbap is the first representative Korean food that comes to mind when it comes to Korean taste. It is one of the first foods foreigners enter when they visit Korea, and the neat plating with various ingredients attracts attention visually.',
      },
    ],
    contentText:
      'K-Food has developed recipes using various ingredients such as grains, meat, and vegetables. In addition, Korean food made good use of the characteristics of each season and region.',
  },
];

const KDRAMA = [
  {
    contentName: 'K-Drama',
    contentList: [
      {
        img: 'drama_01.jpg',
        title: 'Korean Drama that Captivated the World: Squid Game',
        text: 'The squid game became popular around the world, ranking first in 94 countries of global OTT (Over The Top) Netflix. The squid game has become a catalyst for expanding interest in Korean culture accumulated by creating a global sensation into K-drama.',
      },
      {
        img: 'drama_02.png',
        title: 'Korean Drama that Caused a Sensation in Asia: Crash Landing on You',
        text: 'Crash Landing on You is a Korean drama presented in 190 countries through Netflix. The drama made a splash in Asia, ranking in the top 10 on Netflix for 10 weeks in Japan.',
      },
      {
        img: 'drama_03.jpg',
        title: 'Korean Drama that Made "K-Zombie" Craze Worldwide: Kingdom',
        text: 'Kingdom is an original Netflix drama in 2019, and it gained popularity worldwide by creating a new genre called "K Zombie." Kingdom is set in the Joseon Dynasty, where you can see traditional Korean architecture and clothing.',
      },
    ],
    contentText:
      'Korean dramas have been steadily loved around the world since 2002. And one step further, it is attracting attention from all over the world as it is recognized as an independent genre called "K Drama”.',
  },
];

class Korea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };
  }

  componentDidMount() {}

  renderCarouselPart(cate) {
    return (
      <Grid container>
        {cate.map((data, i) => (
          <Grid container key={`carousel_${i}`}>
            <Grid container justifyContent="center">
              <Grid container justifyContent="center" style={{ maxWidth: 1200 }}>
                <Carousel showThumbs={false} showStatus={false} infiniteLoop={true}>
                  {data.contentList.map((datas) => {
                    return (
                      <div key={datas.title} style={{ position: 'relative' }}>
                        <img src={`${EVENT_IMG}/info/${datas.img}`} alt="" style={{ width: '100%', borderRadius: '5px' }} />
                        <div
                          style={{ position: 'absolute', bottom: 16, padding: 16, textAlign: 'left', backgroundColor: 'rgba(0,0,0,0.1)' }}
                        >
                          <Typography style={{ color: '#fff', fontSize: 'x-large', fontWeight: 'bold' }}>{datas.title}</Typography>
                          <Typography style={{ color: '#fff' }}>{datas.text}</Typography>
                        </div>
                      </div>
                    );
                  })}
                </Carousel>
              </Grid>
            </Grid>
            <Typography
              style={{
                marginTop: 16,
                fontSize: '1.3em',
                // padding: 16,
                // backgroundColor: 'rgba(0,0,0,0.04)',  borderRadius: 5
              }}
            >
              {data.contentText}
            </Typography>
          </Grid>
        ))}
      </Grid>
    );
  }

  customSpacing() {
    return <Grid item xs={12} style={{ borderBottom: '2px solid #efefef', margin: '48px 0' }}></Grid>;
  }

  renderRelated() {
    const DATA = [
      { name: 'SEOUL METROPOLITAN GOVERNMENT', img: 'related_logo_1.png', url: 'https://english.seoul.go.kr/?SSid=101_01' },
      { name: 'VISITSEOUL NET', img: 'related_logo_2.png', url: 'https://english.visitseoul.net/index' },
      { name: 'Imagine your Korea', img: 'related_logo_3.png', url: 'http://english.visitkorea.or.kr/enu/index.kto' },
    ];
    return (
      <Grid container>
        {DATA.map((data) => (
          <Grid container key={data.name} item xs={12} md={4} justifyContent="center">
            <Grid container justifyContent="center">
              <img src={`${EVENT_IMG}/info/${data.img}`} alt="" style={{ width: '100%', maxWidth: 250 }} />
            </Grid>
            <Typography style={{ marginBottom: 16, fontSize: '1.2em', fontWeight: 'bold', textAlign: 'center' }}>{data.name}</Typography>
            <Grid container justifyContent="center">
              <Button
                variant="contained"
                style={{ textTransform: 'none', height: 55, backgroundColor: '#376092', color: '#fff' }}
                endIcon={<FaArrowAltCircleRight />}
                onClick={() => {
                  window.open(`${data.url}`, '_blank');
                }}
              >
                Details
              </Button>
              {/* <Chip color="primary" label="Details" icon={<FiArrowRightCircle />} /> */}
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  }
  renderButton() {
    const DATA = [
      { id: 'title_1', name: 'About Korea', color: '#376092' },
      { id: 'title_2', name: 'K - Culture & K - Food', color: '#558ed5' },
      { id: 'title_3', name: 'K - POP & K - Drama', color: '#1f4d5e' },
      { id: 'title_4', name: 'Seoul Tour Information', color: '#5f8277' },
      { id: 'title_5', name: 'Virtual Seoul Tour', color: '#8b3631' },
      { id: 'title_6', name: 'Visa & Passport', color: '#237a9d' },
      { id: 'title_7', name: 'Related Websites', color: '#252525' },
    ];
    return (
      <>
        {DATA.map((data) => (
          <Grid item xs={6} md={4} key={data.name}>
            <Button
              color="primary"
              // fullWidth
              variant="contained"
              onClick={() => {
                document.getElementById(`${data.id}`).scrollIntoView({
                  behavior: 'smooth',
                  // , block: 'center'
                });
              }}
              style={{
                // border: `2px double ${data.color}`,
                // background: `${data.color}`,
                // borderRadius: 5,
                // color: '#fff',
                width: '90%',
                fontWeight: 'bold',
                fontSize: '1.4em',
                textTransform: 'none',
              }}
            >
              {data.name}
            </Button>
          </Grid>
        ))}
      </>
    );
  }

  render() {
    // const { classes, theme } = this.props;

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={7} SIdx={2} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>About Korea</MainTitle>
              <Grid container spacing={2}>
                {this.renderButton()}
              </Grid>
              {this.customSpacing()}
              {/* intro */}
              <Grid container id={'title_1'}>
                <SubTitle>About Korea</SubTitle>
                <Stack direction={'column'}>
                  <Grid container justifyContent="center">
                    <img src={`${EVENT_IMG}/info/korea_map.jpg`} alt="img" style={{ width: '100%', maxWidth: 800 }} />
                  </Grid>
                  <Grid style={{ backgroundColor: 'rgba(0,0,0,0.04)', padding: 16, borderRadius: 5 }}>
                    <Typography style={{ wordBreak: 'keep-all', fontSize: '1.2em', lineHeight: 1.8 }}>
                      The Republic of Korea (herein after Korea) is a country visited by approximately ten million international travelers
                      every year. With its long history in culture and tradition, the country has a lot to offer to travelers. The Korean
                      peninsula, roughly 1,030 kilometers long and 175 kilometers wide at its narrowest point, is located in Northeast Asia.
                      With Seoul as its capital city, Korea's total land area is 100,363 kilometers squared. Korea's neighbors include Japan
                      to the east, China to the west, and Democratic People's Republic of Korea (North Korea) across the northern border.
                    </Typography>
                  </Grid>
                </Stack>
              </Grid>

              {this.customSpacing()}
              {/* carousel content */}
              {/* row 1 */}
              <Grid container item xs={12}>
                <Grid container id={'title_2'}>
                  <SubTitle>K - Culture & K - Food</SubTitle>
                </Grid>
                <Grid item xs={12} md={6} style={{ padding: 8 }}>
                  {this.renderCarouselPart(KCULTURE)}
                </Grid>
                <Grid item xs={12} md={6} style={{ padding: 8 }}>
                  {this.renderCarouselPart(KFOOD)}
                </Grid>
              </Grid>
              {this.customSpacing()}
              {/* row 2 */}
              <Grid container item xs={12}>
                <Grid container id={'title_3'}>
                  <SubTitle>K - POP & K - Drama</SubTitle>
                </Grid>
                <Grid item xs={12} md={6} style={{ padding: 8 }}>
                  {this.renderCarouselPart(KPOP)}
                </Grid>
                <Grid item xs={12} md={6} style={{ padding: 8 }}>
                  {this.renderCarouselPart(KDRAMA)}
                </Grid>
              </Grid>

              {this.customSpacing()}
              {/* Seoul Tour Information */}
              <Grid container id={'title_4'}>
                <SubTitle>Seoul Tour Information</SubTitle>
              </Grid>
              <Grid container>
                <Grid container justifyContent="center" item xs={4} style={{ padding: 8 }}>
                  <img
                    alt=""
                    className="tour_img"
                    src={`${EVENT_IMG}/info/tour_img_1.png`}
                    style={{ width: '100%', borderRadius: '5px', cursor: 'pointer' }}
                    onClick={() => {
                      window.open('https://english.visitseoul.net/map-guide-book', '_blank');
                    }}
                  />
                  <Typography style={{ fontWeight: 'bold', color: '#237a9d', fontSize: 20, marginTop: 8 }}>Guidebooks & Maps</Typography>
                </Grid>
                <Grid container justifyContent="center" item xs={4} style={{ padding: 8 }}>
                  <img
                    alt=""
                    className="tour_img"
                    src={`${EVENT_IMG}/info/tour_img_2.png`}
                    style={{ width: '100%', borderRadius: '5px', cursor: 'pointer' }}
                    onClick={() => {
                      window.open('https://www.seoulsolution.kr/en/content/statistic-seoul', '_blank');
                    }}
                  />
                  <Typography style={{ fontWeight: 'bold', color: '#237a9d', fontSize: 20, marginTop: 8 }}>Seoul at a Glance</Typography>
                </Grid>
                <Grid container justifyContent="center" item xs={4} style={{ padding: 8 }}>
                  <img
                    alt=""
                    className="tour_img"
                    src={`${EVENT_IMG}/info/tour_img_3.png`}
                    style={{ width: '100%', borderRadius: '5px', cursor: 'pointer' }}
                    onClick={() => {
                      window.open('https://english.visitseoul.net/editorspicks', '_blank');
                    }}
                  />
                  <Typography style={{ fontWeight: 'bold', color: '#237a9d', fontSize: 20, marginTop: 8 }}>Recommendations</Typography>
                </Grid>
              </Grid>
              {this.customSpacing()}
              {/* Virtual Seoul Tour */}
              <Grid container id={'title_5'}>
                <SubTitle>Virtual Seoul Tour</SubTitle>
              </Grid>
              <Grid container>
                <Grid container justifyContent="center" item xs={12} md={6}>
                  <Grid container justifyContent="flex-start" style={{ paddingRight: 16 }}>
                    <Typography style={{ wordBreak: 'keep-all', fontSize: '1.2em', lineHeight: 1.8 }}>
                      Meet the attractive Seoul lively with 360 VR videos in various themes. Take a virtual tour to landmarks and unique
                      venues of Seoul and experience the interesting teambuilding programs as well.
                    </Typography>
                    <Button
                      // color="primary"
                      variant="contained"
                      style={{ textTransform: 'none', height: 55, backgroundColor: '#376092', color: '#fff' }}
                      onClick={() => {
                        window.open('https://www.miceseoul.com/virtualseoultour', '_blank');
                      }}
                    >
                      Go to Virtual Seoul Tour
                    </Button>
                  </Grid>
                </Grid>
                <Grid container justifyContent="center" item xs={12} md={6}>
                  <img
                    src={`${EVENT_IMG}/info/virtual_img.jpg`}
                    alt=""
                    style={{ width: '100%', borderRadius: '5px' }}
                    onClick={() => {
                      window.open('https://www.miceseoul.com/virtualseoultour', '_blank');
                    }}
                  />
                </Grid>
              </Grid>
              {this.customSpacing()}
              {/* Visa & Passport */}
              <Grid container id={'title_6'}>
                <SubTitle>Visa & Passport</SubTitle>
              </Grid>
              <Grid container>
                <Grid>
                  <Typography style={{ wordBreak: 'keep-all', fontSize: '1.2em', lineHeight: 1.8 }}>
                    All visitors to enter the Republic of Korea must have a valid passport and visa. Visitors with roundtrip tickets from
                    countries who have a special agreement with Korea may be exempt from the visa requirement, and can stay in Korea
                    visa-free for up to 30 days, or 90 days, depending on the type of agreement between two countries. Please contact the
                    Korean embassy or a consulate in your country as early as possible.
                  </Typography>
                </Grid>
                <Grid container style={{ margin: '8px 0' }}>
                  <Typography>
                    <b>For more information:</b> &nbsp;&nbsp;
                    <a href="https://www.mofa.go.kr/eng/index.do" target="_blank" style={{ cursor: 'pointer' }}>
                      https://www.mofa.go.kr/eng/index.do
                    </a>
                  </Typography>
                </Grid>
                <Grid container style={{ margin: '8px 0' }}>
                  <Typography>
                    <b>Quarantine regulations (Incheon Airport):</b> &nbsp;&nbsp;
                    <a href="https://www.airport.kr/ap_cnt/en/svc/covid19/medical/medical.do" target="_blank" style={{ cursor: 'pointer' }}>
                      https://www.airport.kr/ap_cnt/en/svc/covid19/medical/medical.do
                    </a>
                  </Typography>
                </Grid>
              </Grid>
              {this.customSpacing()}
              {/* Related Websites */}
              <Grid container id={'title_7'}>
                <SubTitle>Related Websites</SubTitle>
              </Grid>
              <Grid container>{this.renderRelated()}</Grid>
              {this.customSpacing()}
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Korea);
